import { slicedToArray as _slicedToArray, defineProperty as _defineProperty } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import React, { useState } from 'react';
import { usePathContext } from '../../../../context/PathContext.js';
import classNames from 'classnames';
import range from 'lodash/range';
import styles from './styles.css.js';
import Star from './star.svg.js';

var StarRatingQuestion = function StarRatingQuestion(_ref) {
  var numericValue = _ref.numericValue,
      _ref$maxRating = _ref.maxRating,
      maxRating = _ref$maxRating === void 0 ? 5 : _ref$maxRating,
      disabled = _ref.disabled,
      onStarSelected = _ref.onStarSelected;

  var _useState = useState(numericValue || ''),
      _useState2 = _slicedToArray(_useState, 2),
      starRating = _useState2[0],
      setStarRating = _useState2[1];

  var pathContext = usePathContext(); // Shift the rating up one since `range` is not inclusive

  var ratings = range(1, maxRating + 1);

  var populateStarSelection = function populateStarSelection(rating) {
    setStarRating(rating);
    onStarSelected(rating);
  };

  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: styles.starWrapper
  }, ratings.map(function (rating) {
    return React.createElement("button", {
      type: "button",
      className: styles.starButton,
      key: rating,
      disabled: disabled,
      onClick: function onClick() {
        if (rating !== parseInt(starRating, 10)) {
          populateStarSelection(rating.toString());
        }
      }
    }, React.createElement(Star, {
      className: classNames(_defineProperty({}, styles.selected, parseInt(starRating, 10) >= rating))
    }));
  })), React.createElement("div", {
    className: styles.dialog
  }, React.createElement("div", {
    className: classNames(styles.desktopHeader, _defineProperty({}, styles.placementDefault, pathContext.pathPlacement == 'default'))
  }, React.createElement("strong", null, "Your feedback matters!")), React.createElement("div", {
    className: styles.body
  }, "Every review allows our experts to help you better"), React.createElement("div", null, React.createElement("strong", null, "Thanks you for shopping with us!"))));
};

export default StarRatingQuestion;
//# sourceMappingURL=index.js.map
